export default "__VITE_ASSET__83364292__"